export const SAVE_ALL_VEHICLE_GROUPS = 'SAVE_ALL_VEHICLE_GROUPS'
export const SAVE_VEHICLE_GROUP = 'SAVE_VEHICLE_GROUP'
